<template>
  <div id="app">
    <Head></Head>
    <Nav></Nav>
    
    <router-view/>
    <Footer></Footer>
    <Last></Last>
  </div>
</template>

<script>
	import Head from './components/common/Head';
	import Nav from './components/common/Nav';
	import Footer from './components/common/Footer';
	import Last from './components/common/Last';
export default {
  name: 'App',
  components:{Head,Nav,Footer,Last},
  data(){
  	return{
      msg:'dfgf',
      siteName:'天图智能',
  		describe:'',
  	}
  },
  methods:{
    getInfo(){
      this.axios({
        method: 'get',
        url: this.GLOBAL.getInfoApi,
        data: {}
      })
      .then((res) => {
        this.logo = res.data.data.logo;
        this.siteName = res.data.data.siteName;
        this.describe = res.data.data.describe;
        $('#headTitle').text(this.siteName);
        $('meta[name="keywords"]').attr('content',this.siteName);
        $('meta[name="description"]').attr('content',this.describe);
        console.log(this.describe);
      })
      .catch((err) => {
        console.log(err)
      })
    }
  },
  created(){
    this.getInfo();
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue